import { ActionType, ActionTypes } from '../actions/index';
import { IAppAction } from '../actions/app-actions';
import * as redux from 'redux';

export interface IApplicationModel {
    viewFromSeatModalActive: boolean;
    loading: boolean;
}

let defaultApplicationModel = {
    viewFromSeatModalActive: false,
    loading: false
};

export { defaultApplicationModel };

export function applicationModel(state: IApplicationModel = defaultApplicationModel, action: IAppAction) {
    switch (action.type) {
        case ActionTypes.OPEN_SEATVIEW_MODAL:
            return { ...state, viewFromSeatModalActive: true };
        case ActionTypes.CLOSE_SEATVIEW_MODAL:
            return { ...state, viewFromSeatModalActive: false };
        case ActionTypes.LOADING_SCREEN:
            return { ...state, loading: action.value };
        //case ActionTypes.SET_PACKAGE_TICKET_QUANTITIES:
        //    return { ...state, packageTicketQuantity: JSON.parse(action.value) };
        default:
            return state
    }
}